/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {Suspense, useEffect} from 'react';
import {useRecoilState, useRecoilValue, useSetRecoilState} from 'recoil';
import {Device} from '@capacitor/device';
import {Capacitor} from '@capacitor/core';
import cc from 'classcat';
import {useNavigate} from 'react-router-dom';

import BannerScroller from '@/components/home/BannerScroller';
import QuickMenu from '@/components/home/QuickMenu';
import usePushNotification from '@/hooks/usePushNotification';
import Fetcher from '@/components/common/Fetcher';
import {getHomeNewZip} from '@/services/magazine';
import {
  HomeOpacity,
  deviceId,
  user,
  HomeKnewZipCard,
  HomeKnewZipIdx,
  AddressList,
} from '@/store';
import {useScroll} from '@/hooks/useScroll';
import useGeoLocation from '@/hooks/useGeoLocation';
import Container from '@/container';
import Layout from '@/layouts';
import {registDevice} from '@/services/user';
import AddressSelector from '@/components/community/AddressSelector';
import {useGetHomeBanners, useGetSubCuration} from '@/hooks/queries/brands';

import styles from './styles.module.scss';
import SubCuration from './components/SubCuration';

// const dummyMagazine: MagazineItem = {
//   id: 1,
//   author: {
//     badge: null,
//     id: 1,
//     nickname: '더미작성자',
//     profileImage: 'https://dummy-profile.jpg',
//   },
//   title: '더미 매거진',
//   subtitle: '더미 서브타이틀',
//   bannerTitle: '더미 배너 타이틀',
//   type: 'brands',
//   imageUrl: 'https://dummy-image.jpg',
//   bannerImageUrl: 'https://dummy-banner.jpg',
//   link: '/dummy-link',
//   priority: 1,
//   created: '2024-03-20',
//   commentCount: 0,
//   likeCount: 0,
//   bookmarkCount: 0,
//   viewCount: 0,
//   isLike: false,
//   hashtags: ['더미태그1', '더미태그2'],
//   category: 'brands',
//   target: 'place',
//   isBookmark: false,
//   popupInfo: {
//     id: 1,
//     status: 'active',
//     popupBegin: '2024-03-20',
//     popupEnd: '2024-04-20',
//     sellBegin: '2024-03-20',
//     sellEnd: '2024-04-20',
//     couponAvailable: false,
//     options: [
//       {
//         id: 1,
//         amount: 10000,
//         limit: 100,
//         popup: 1,
//         soldCount: 0,
//         type: 'date',
//         value: '2024-03-20',
//         limitPerUser: 5,
//         child: [],
//       },
//     ],
//   },
// };

export default function Home() {
  const navigator = useNavigate();
  const userAccessToken = useRecoilValue(user);
  const {initNotificationList, checkMarketingAllow} = usePushNotification();
  const setDeviceId = useSetRecoilState(deviceId);
  const setZipIdx = useSetRecoilState(HomeKnewZipIdx);
  const [homeOpacity, setHomeOpacity] = useRecoilState(HomeOpacity);
  const [homeZipCards, setHomeZipCards] = useRecoilState(HomeKnewZipCard);
  const {data: bannerData} = useGetHomeBanners();
  const {data: subCurationData} = useGetSubCuration();
  const addressList = useRecoilValue(AddressList);
  const {syncScroll} = useScroll();
  const {getToken} = usePushNotification();
  const {
    setIsAreaSelected,
    setCoordinates,
    setIsRenderComplete,
    setZoomLevel,
    setMovedCoordinates,
  } = useGeoLocation();

  const saveDeviceInfo = async () => {
    const {identifier} = await Device.getId();
    const platform = (await Device.getInfo()).platform;
    const token = await getToken();
    setDeviceId(identifier);
    await registDevice(
      {
        deviceId: identifier,
        registrationId: token,
        type: platform as 'ios' | 'android',
        isActive: true,
      },
      userAccessToken,
    );
  };

  const getData = async () => {
    const res = await getHomeNewZip();
    const zips = (res.data.newzip as ZipCollectionItem[]).map(m => {
      let cardList = m.zipList;
      cardList = cardList.splice(0, 3);
      cardList.unshift(m as unknown as NewZipCard);
      return cardList;
    }) as NewZipCard[][];
    return zips;
  };

  const updateAddress = (
    address2: string,
    address3: string,
    coords?: number[],
  ) => {
    setIsRenderComplete(false);
    setMovedCoordinates({
      latitude: null,
      longitude: null,
      error: null,
    });
    setZoomLevel(15);
    setIsAreaSelected && setIsAreaSelected(true);
    if (coords && setCoordinates) {
      setCoordinates({
        latitude: coords[0],
        longitude: coords[1],
        error: null,
      });
    }
    navigator('/map');
  };

  useEffect(() => {
    if (Capacitor.getPlatform() !== 'web') {
      if (userAccessToken) {
        saveDeviceInfo();
      }
      initNotificationList();
      checkMarketingAllow();
    }
    // Set Home knewzip card set index randomly
    setZipIdx(Math.floor(Math.random() * homeZipCards.length));
    syncScroll();
  }, [homeZipCards]);

  useEffect(() => {
    console.log(bannerData);
  }, [bannerData]);
  return (
    <Container.Home>
      <Fetcher
        fetcher={getData}
        setter={setHomeZipCards}
        animationFn={() => setHomeOpacity(1)}
        fixedHeader>
        <div className={cc(['home', {[styles.contents]: homeOpacity === 1}])}>
          <BannerScroller />
          <QuickMenu />
          <div
            style={{height: '0px', width: '100%', background: '#F7F7FC'}}></div>
          <div>
            {bannerData && bannerData.length > 0 && (
              <a
                key={bannerData[0].id}
                href={bannerData[0].link}
                style={{padding: '0px 20px', display: 'block'}}>
                <img
                  src={bannerData[0].image}
                  alt=""
                  style={{
                    width: '100%',
                    borderRadius: '4px',
                    objectFit: 'cover',
                  }}
                />
              </a>
            )}
          </div>
          <Suspense>
            <SubCuration subCurationItems={subCurationData} />
          </Suspense>
          <Layout.Footer type="home" />
        </div>
        <AddressSelector
          addressList={addressList}
          updateAddress={updateAddress}
          callback={() => {
            navigator('/map');
          }}
        />
      </Fetcher>
    </Container.Home>
  );
}
